export const INSTRUCTION = "說明：\n"
  + "1. 下載題目後, 可點選本系統右上角\"-\"圖示縮小至工具列後, 請使用桌面上所提供的開發工具作答。\n"
  + "2. 作答檔案的檔名須依照題目指示命名, 大小寫須一致。副檔名須依照使用的程式語言命名為.c、 .cpp、 .java或.py。\n"
  + "3. 作答結果上傳時, 請先選擇所使用的程式語言, 再點選上傳程式碼按鈕, 選擇要上傳的作答程式碼檔案即可。請勿上傳執行檔！";
